import { Button } from "@/components/ui/button";
import { Clock, Phone } from "lucide-react";

const EmergencyBanner = () => {
  return (
    <section className="py-16 bg-accent/10 border-y border-accent/20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-accent/20 rounded-full flex items-center justify-center">
              <Clock className="w-8 h-8 text-accent" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Need Urgent Help?
          </h2>
          <p className="text-lg text-muted-foreground mb-6">
            Garage door stuck, broken spring, or security concern? We offer 24/7 emergency callouts 
            across Berkshire, Hampshire & Surrey when you need us most.
          </p>
          <Button size="lg" className="gap-2 text-lg px-8 py-6 bg-accent hover:bg-accent/90" asChild>
            <a href="tel:07836393815">
              <Phone className="w-5 h-5" />
              Call: 07836 393815
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default EmergencyBanner;